import { render } from "./Index_news_en.vue?vue&type=template&id=b47df61a&scoped=true"
import script from "./Index_news_en.vue?vue&type=script&lang=js"
export * from "./Index_news_en.vue?vue&type=script&lang=js"

import "./Index_news_en.vue?vue&type=style&index=0&id=b47df61a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b47df61a"

export default script